<template>
  <div id="article-menus">
    <div id="article-menu">
      <ul id="article-list">
        <li class="article-list" v-for="(article, index) in articles" :key="index" :class="{active: article.articleIndex == currentArticle.articleIndex}"  @click="goToArticle(index)">
            {{article.title}}
        </li>
      </ul>
    </div>
    <div id="article-menu-sm" style="display:none;">
      <ul id="article-list">
        <li class="article-list" v-for="(article, index) in articles" :key="index" :class="{active: article.articleIndex == currentArticle.articleIndex}"  @click="goToArticle(index)">
            {{article.title}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        "articles",
        "articleLink",
        "currentArticle",
      ]),

    },
    methods: {
      ...mapMutations({
      }),

      ...mapActions([
        "goToArticle"
      ])
    },
    
  }

</script>

<style scoped>
  #article-menu {
    position: fixed;
    right:0;
    background: #214283;
    width: 20%;
    /* width:360px; */
    text-align: right;
    top: 48px;
    height: calc(100vh - 48px);
    overflow-y: scroll;
    z-index: 5;
  }
  
  #article-menu ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: block;
    padding: 10px;
    color: #fff;
    text-decoration: none;
    border-bottom: 1px solid #fff;
    font-weight:600;
    cursor: pointer;
    /* font-family: 'FrutigerLTPro-Light' */
  }

  #article-menu-sm {
    position: fixed;
    right:0;
    background: #214283;
    width: 20%;
    /* width:360px; */
    text-align: right;
    top: 48px;
    height: calc(100vh - 48px);
    overflow-y: scroll;
    z-index: 5;
    display:none;
  }
  
  #article-menu-sm ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: block;
    padding: 10px;
    color: #fff;
    text-decoration: none;
    border-bottom: 1px solid #fff;
    font-weight:600;
    cursor: pointer;
    /* font-family: 'FrutigerLTPro-Light' */
  }

  /* .article-list:hover, */
  .article-list.active {
    background-color: #fff;
    color: #214283;
  }

  @media (max-width: 1199px) {
  li {
    font-size: 0.8em;
  }

  @media (max-width: 768px) {
    #article-menu {
      display:none;
    }

    #article-menu-sm {
      display:none;
      width:150px;
    }
    li {
      font-size: 0.6em;
    }
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/ArticleMenu.vue